import { useQuery } from "react-query";
import { enrollmentApiRequest } from "./client";
var GradeMetricType = /* @__PURE__ */ ((GradeMetricType2) => {
  GradeMetricType2["OVERALL"] = "OVERALL";
  GradeMetricType2["ACTUAL"] = "ACTUAL";
  GradeMetricType2["RELATIVE"] = "RELATIVE";
  return GradeMetricType2;
})(GradeMetricType || {});
const fetchEnrollmentProgressReport = (enrollmentId) => {
  return enrollmentApiRequest({
    url: `/enrollment-report/${enrollmentId}/progress`,
    method: "GET"
  });
};
function useEnrollmentProgressReportQuery(enrollmentId) {
  return useQuery(
    ["enrollmentProgressReport", enrollmentId],
    () => fetchEnrollmentProgressReport(enrollmentId),
    { useErrorBoundary: true }
  );
}
export {
  GradeMetricType,
  useEnrollmentProgressReportQuery
};
